import type { MessageData } from '@elara/domain/models/schemas/message-schemas';

import { createState } from '#lib/signals-utils.js';

export function createChatDebugState() {
  const state = createState({
    messages: [] as MessageData[],
    messageCount: 0,
    agentId: undefined as string | undefined,
    lastActivity: undefined as Date | undefined,
  });
  return state;
}

/** A reactive store holding state specifically for the debug panel. All properties are signals transparent to the user. */
export type ChatDebugState = ReturnType<typeof createChatDebugState>;
